module.exports = __webpack_public_path__ + "img/christmas-hero-v2.f68b68de.jpg";